class ManciniEditorialPage extends HTMLElement {
  connectedCallback() {
    this.addEventListener('toggle', this.#handleDetailsToggle, true);

    this.contactForm = this.querySelector('.mancini-contact__form');
    if (this.contactForm) {
      this.contactForm.addEventListener('invalid', this.#handleInvalidField, true);
      this.contactForm.addEventListener('input', this.#handleFieldUpdate);
      this.contactForm.addEventListener('change', this.#handleFieldUpdate);
    }

    const status = this.querySelector('[data-contact-success], [data-contact-errors]');
    if (status) {
      window.requestAnimationFrame(() => status.focus());
    }
  }

  disconnectedCallback() {
    this.removeEventListener('toggle', this.#handleDetailsToggle, true);

    if (this.contactForm) {
      this.contactForm.removeEventListener('invalid', this.#handleInvalidField, true);
      this.contactForm.removeEventListener('input', this.#handleFieldUpdate);
      this.contactForm.removeEventListener('change', this.#handleFieldUpdate);
    }
  }

  #handleInvalidField = (event) => {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;

    this.#showFieldError(field);
  };

  #handleFieldUpdate = (event) => {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;

    if (field.validity.valid) {
      this.#clearFieldError(field);
    }
  };

  #showFieldError(field) {
    if (!field.id || field.validity.valid) return;

    const fieldGroup = field.closest('.mancini-contact__field, .mancini-contact__consent');
    if (!fieldGroup) return;

    const errorId = `${field.id}-error`;
    let error = field.ownerDocument.getElementById(errorId);

    if (!error) {
      error = field.ownerDocument.createElement('p');
      error.id = errorId;
      error.className = 'mancini-contact__field-error';
      error.dataset.fieldError = '';
      error.setAttribute('role', 'alert');

      if (fieldGroup.classList.contains('mancini-contact__consent')) {
        fieldGroup.insertAdjacentElement('afterend', error);
      } else {
        fieldGroup.append(error);
      }
    }

    if (field.validity.valueMissing && field.dataset.requiredMessage) {
      error.textContent = field.dataset.requiredMessage;
    } else if (field.validity.typeMismatch && field.dataset.typeMessage) {
      error.textContent = field.dataset.typeMessage;
    } else {
      error.textContent = field.validationMessage;
    }
    field.setAttribute('aria-invalid', 'true');

    const describedBy = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
    describedBy.add(errorId);
    field.setAttribute('aria-describedby', [...describedBy].join(' '));
  }

  #clearFieldError(field) {
    if (!field.id) return;

    const errorId = `${field.id}-error`;
    field.ownerDocument.getElementById(errorId)?.remove();

    const describedBy = (field.getAttribute('aria-describedby') || '')
      .split(/\s+/)
      .filter((id) => id && id !== errorId);

    if (describedBy.length > 0) {
      field.setAttribute('aria-describedby', describedBy.join(' '));
    } else {
      field.removeAttribute('aria-describedby');
    }

    field.removeAttribute('aria-invalid');
  }

  #handleDetailsToggle = (event) => {
    const currentDetails = event.target;
    if (!(currentDetails instanceof HTMLDetailsElement) || !currentDetails.open) return;

    const group = currentDetails.closest('[data-single-open]');
    if (!group) return;

    for (const details of group.querySelectorAll('details[open]')) {
      if (details !== currentDetails) details.open = false;
    }
  };
}

if (!customElements.get('mancini-editorial-page')) {
  customElements.define('mancini-editorial-page', ManciniEditorialPage);
}
